module.exports = __webpack_public_path__ + "img/404_error.a551c521.png";